/* eslint eqeqeq : 'off' */
import React,{Component} from "react";
import WorkorderWrapper from "./WorkOrderWrapper";
import AlarmWrapper from "./AlarmWrapper";
import PreventativeMaintenanceWrapper from "./PreventativeMaintenanceWrapper";
import { connect } from "react-redux";
//import CreateWorkOrder from "./_ModalsForms/CreateWorkOrder";
//import CreatePreventativeMaintenance from "./_ModalsForms/CreatePreventativeMaintenance";
//import { Modal } from 'reactstrap';
import { getAllResources, getUserDetailsAfterLogin } from '../../../action/cultureAction';
import { WorkOrderRolePermission } from '../../../action/authenticateUser';
import { GetMailSetting } from '../../../action/workorderAction';
import ChillerRotation from "components/EnsembleComponents/Summary/ChillerPlantSummary/ChillerRotation";

class EquipmentWrapper extends Component {

    componentWillMount() {
        this.props.getUserDetailsAfterLogin();
        this.props.getAllResources();
        this.props.WorkOrderRolePermission(24);
        this.props.GetMailSetting();
    }

    // componentWillReceiveProps(nextProps) {
    //     if (this.props != nextProps) {
    //       var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
    //       if (modalClose == "close") {
    //         this.setState({ modal: false });
    //       }
    //     }
    // }
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
        this.toggle = this.toggle.bind(this);
        this.WrapperPopupCancel = this.WrapperPopupCancel.bind(this);
    }

    toggle() {
        console.log('event handling');
        this.setState({
            modal: !this.state.modal
        });

    }

    WrapperPopupCancel() {
        this.setState({
            modal: false
        });
    } 

    render() {
        const chillerPlantSummaryPage = window.location.href && window.location.href.includes("ChillerPlantSummary.aspx");
        return (
            <div>
                {
                    chillerPlantSummaryPage ? <ChillerRotation /> : null
                }
            <div id='Workorder'>
                <WorkorderWrapper Premise={this.props.OnPremises}  ForEquipment={true} EquipmentSummaryId={this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0]} />
                {/* <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{'max-width':'750px !important'}}>
                    <CreateWorkOrder Premise={this.props.OnPremises} ForEquipment={true} EquipmentSummaryId={this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0]} OnPopupCancel={this.WrapperPopupCancel}  />
                </Modal> */}
            </div>
            <div id='PreventativeMaintenance'>
                <PreventativeMaintenanceWrapper shouldCreatePortal portalId="portal-root" Premise={this.props.OnPremises}  ForEquipment={true} EquipmentSummaryId={this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0]} />
                {/* <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <CreatePreventativeMaintenance Premise={this.props.OnPremises} ForEquipment={true} EquipmentSummaryId={this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0]} />
                </Modal> */}
            </div>
            <div id='Alarms'>
                <AlarmWrapper ref={(AlarmWrapper) => {window.EquipmentAlarmWrapper = AlarmWrapper}} />
            </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        EquipmentSummary: state.authService.EquipmentSummaryDetail,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAllResources: () => dispatch(getAllResources()),
        getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
        WorkOrderRolePermission: (applicationId) => dispatch(WorkOrderRolePermission(applicationId)),
        GetMailSetting: () => dispatch(GetMailSetting())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentWrapper)

